import * as React from 'react';

import {
  Alert,
  AlertTitle,
  Box,
  Collapse,
  Paper,
  Typography,
} from '@mui/material';

import { useSnackbar } from 'notistack';

import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';
import useGetApprovalList from '../../core/api/hooks/flight-event/useGetApprovalList';
import useGetAlertFromLocationState from '../../core/api/hooks/common/useGetAlertFromLocationState';
import FormCard from '../../components/FormCard';
import FormPaper from '../../components/FormPaper';
import FlightEventList from './FlightEventList';
import { getColor } from '../../core/colors';
import { EventFormStatus } from '../../core/api/clients';
import FlightEventDraftsAndSubmissions from './FlightEventDraftsAndSubmissions';

function FlightEventHome() {
  const { metadata, ...roles } = useAuthorizedFormData();
  const { enqueueSnackbar } = useSnackbar();

  const { message, isError, title, displayAlert } = useGetAlertFromLocationState();

  React.useEffect(() => {
    if (message && title && displayAlert) {
      enqueueSnackbar(message, { variant: isError ? 'error' : 'default' });
    }
  }, [message, isError, title, displayAlert]);

  if (!metadata) {
    return (
      <Alert severity="error">
        <AlertTitle>Error - Metadata not found</AlertTitle>
      </Alert>
    );
  }

  return (
    <React.Fragment>
      <Collapse in={roles.isContributor}>
        <FormCard
          disableAvatar
          disableLink
          color={metadata.color}
          rootRoute={metadata.route}
          title={metadata.reportType}
        >
          <FlightEventDraftsAndSubmissions formMetadata={metadata} />
        </FormCard>
      </Collapse>
      <Collapse in={roles.isAdministrator || roles.isApprover || roles.isReader}>
        <FormPaper color={metadata.color}>
          <Box display="flex" alignItems="center" sx={{ mt: 1, mb: 2 }}>
            <Box display="flex" alignItems="center" flexGrow={1}>
              <Typography sx={{ mr: 2 }} variant="h5">
                All Flight Event Forms
              </Typography>
            </Box>
          </Box>
          <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
            <FlightEventList
              statuses={[EventFormStatus.Submitted, EventFormStatus.Approved, EventFormStatus.Final]}
              pageSize={25}
            />
          </Paper>
        </FormPaper>
      </Collapse>
    </React.Fragment>
  );
}

export default FlightEventHome;
